import React from 'react'

interface Props {
    goOn: () => void
}
export default function WarningMobile(props: Props) {

    return (
        <div className='flex w-full h-full justify-center items-center bg-gray-200'>
            <div className='flex flex-col justify-center items-center text-center px-10'>
                <span className='font-bold text-lg mb-2'>به درایو امن سایبرنو خوش آمدید</span>
                <span className='font-medium'>این سامانه فقط برای رایانه‌ها طراحی شده است و قابل استفاده در تلفن همراه نیست.</span>
                <button className='text-white rounded-full px-8 py-3 primary_bg_color mt-5' onClick={()=>props.goOn()}>تمایل به ادامه دارم</button>
            </div>
        </div>
    )
}
